<template>
<div class="chapter">
<div class="inner_page">
<h1 class="hide">Full Title</h1>
<p class="Basic-Paragraph para-style-override-15">Coast Guard Heroes</p>
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph para-style-override-15">of New Orleans</p>
</div>
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph para-style-override-9"><span class="char-style-override-13">Capt Robert Mueller, USCG </span><span class="char-style-override-14">(ret)</span></p>
</div>
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph para-style-override-16">Foreword by Rear Adm. Joseph Castillo, <br/>U.S. Coast Guard (ret)</p>
</div>
<div class="frame-2">
<img alt="PELOGO.TIF" class="frame-3" src="Images/PELOGO_fmt.jpeg"/>
</div>
<p class="Basic-Paragraph para-style-override-6"></p>
<p class="Basic-Paragraph para-style-override-7">Pelican Publishing Company</p>
<p class="Basic-Paragraph para-style-override-4"><span class="char-style-override-5">Gretna 2016</span><span class="char-style-override-5"></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FullTitle.vue?2d736898